import React from "react";
import i18next from "i18next";

type TourStep = {
  title: string | JSX.Element;
  target: string;
  content: JSX.Element;
  placement: string;
  disableBeacon: boolean;
};

const createStep = (title: string, target: string, description: string): TourStep => ({
  title: <h4 className="tourTitle">{title}</h4>,
  target,
  content: <p className="pageTour">{description}</p>,
  placement: "right-start",
  disableBeacon: true,
});

const tourStepsKeys: Record<"search" | "table" | "charts" | "maps", { key: string; label: string; description: string; roles: string[] }[]> = {
  search: [
    { key: "msg-types", label: "TS_core:JR_CHSelectMsg", description: "TS_core:JR_CHSelectMsgDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "search-section", label: "TS_core:Search", description: "TS_core:JR_CHSearchDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "search-result", label: "TS_core:JR_CHSearchResults", description: "TS_core:JR_CHSearchResultDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "result-number", label: "TS_core:JR_CHMsgTypes", description: "TS_core:JR_CHMsgTypesDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "excel-export", label: "TS_core:JR_CHExportBtn", description: "TS_core:JR_CHExportBtnDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "excel-export", label: "TS_core:JR_CHExportBtnTip", description: "TS_core:JR_CHExportBtnTipDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
  ],
  table: [
    { key: "ch-table", label: "TS_core:Table", description: "TS_core:JR_CHTableDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "ch-table-data", label: "TS_core:JR_CHTableView", description: "TS_core:JR_CHTableViewDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "sort-icon", label: "TS_core:JR_CHSort", description: "TS_core:JR_CHSortDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "close-column", label: "TS_core:JR_CHHideColumns", description: "TS_core:JR_CHHideColumnsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "reset-to-default", label: "TS_core:ResetDefaultColumns", description: "TS_core:JR_CHResetColumnsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "add-columns-to-table", label: "TS_core:AddcolumnstoTable", description: "TS_core:JR_CHAddColumnsToTable", roles: ["Admin", "GTS", "FQ"] },
    { key: "latency-icons", label: "TS_core:LatencyIndicator", description: "TS_core:JR_CHLatencyIndicatorsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] }
  ],
  charts: [
    { key: "ch-charts", label: "TS_core:Charts", description: "TS_core:JR_CHChartsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
    { key: "time-line-chart", label: "TS_core:JR_CHTimeLineChart", description: "TS_core:JR_CHTimeLineChartDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance", "Basic", "Workshop"] },
  ],
  maps: [
    { key: "ch-map", label: "TS_core:Map", description: "TS_core:JR_CHMapsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance"] },
    { key: "ch-map-settings", label: "TS_core:JR_CHMapSettings", description: "TS_core:JR_CHMapSettingsDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance"] },
    { key: "ch-map-resize", label: "TS_core:JR_CHMapResize", description: "TS_core:JR_CHMapResizeDescription", roles: ["Admin", "GTS", "FQ", "LoTH", "Assistance"] },

  ],
};

const generateEquipmentTourStepsByRole = (userRole: string, type: keyof typeof tourStepsKeys) => {
  return (tourStepsKeys[type] || [])
    .filter((step) => step.roles.includes(userRole))
    .map(({ key, label, description }) =>
      createStep(i18next.t(label), `#${key}`, i18next.t(description))
    );
}

export default generateEquipmentTourStepsByRole;
